import {
  type CloserStatus,
  type CloserModel,
  type SystemCloserStrategyType,
  CLOSER_STATUSES,
  type CloserInteraction,
} from '@terros/common'
import { type SelectItem } from './types'

export const getReadableCloserStatus = (status: CloserStatus): string => {
  switch (status) {
    case 'None':
      return 'None'
    case 'Needs_Help':
      return 'Setter'
    case 'Can_Close':
      return 'Self Gen'
    case 'Can_Help':
      return 'Self Gen & Closer'
    case 'Closer_Only':
      return 'Closer'
  }
}

export const DEFAULT_CLOSER_STATUS: CloserStatus = 'Can_Help'

export const CLOSER_STATUS_ITEMS: SelectItem<CloserStatus>[] = CLOSER_STATUSES.map(
  (status): SelectItem<CloserStatus> => ({
    label: getReadableCloserStatus(status),
    value: status,
  })
)

export const CLOSER_MODELS: SelectItem<CloserModel>[] = [
  {
    label: 'Setter assigns closer',
    value: 'setter',
  },
  {
    label: 'Dispatcher assigns closer',
    value: 'dispatcher',
  },
]

export const SYSTEM_CLOSER_STRATEGY_ITEMS: SelectItem<SystemCloserStrategyType>[] = [
  {
    label: 'Random',
    value: 'random',
  },
  {
    label: 'Balanced',
    value: 'balanced',
  },
  {
    label: 'Preferential',
    value: 'preferential',
  },
  {
    label: 'Performance',
    value: 'performance',
  },
]

export const CLOSER_INTERACTION_ITEMS: SelectItem<CloserInteraction>[] = [
  {
    label: 'Full',
    value: 'Full',
  },
  {
    label: 'Partial',
    value: 'Partial',
  },
  {
    label: 'None',
    value: 'None',
  },
]

export const isSetter = (status: CloserStatus): boolean => status === 'Needs_Help'

export type SalesRole = 'selfgen' | 'closer' | 'setter' | undefined

export const closerStatusToSalesRole = (status?: CloserStatus): SalesRole => {
  if (!status || status === 'None') return undefined
  switch (status) {
    case 'Needs_Help':
      return 'setter'
    case 'Closer_Only':
      return 'closer'
    case 'Can_Close':
    case 'Can_Help':
      return 'selfgen'
  }
}
